import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { IconPlus } from '@tabler/icons-react'
import './styles.scss'

import { Button } from '@fragments'
import PublishPostModal from '@components/_modals/Group/PublishPost'

import { useCommunity } from '@contexts/CommunityContext'
import { useSidebar } from '../SidebarContext'

/**
 * "Share new post" entry point. Full-width pill while the sidebar is open,
 * a round icon button when collapsed. Opens the post composer on its group
 * picker step; only shown to users who manage at least one community, since
 * that is who the "groups available for posting" endpoint serves.
 */
export default function SharePost() {
    const { t } = useTranslation('shell')
    const { collapsed, isMobile, setCollapsed } = useSidebar()
    const { community, loadCommunities } = useCommunity()

    const modalRef = useRef()

    if (!community.hasAtLeastOneAdminPermission) return null

    // After publishing the composer itself navigates to the posted group; here
    // we only report, refresh the sidebar data and get the mobile overlay out
    // of the way of the destination.
    function handleClick() {
        modalRef.current?.open({}, (result) => {
            const points = result?.gamification?.points
            const earned = (points?.post || 0) + (points?.activity || 0)

            window.setSnackbar(
                earned > 0
                    ? t('community:group.pointsEarned', { value: earned })
                    : t('groupModals:publishPost.success')
            )
            loadCommunities()
            if (isMobile) setCollapsed(true)
        })
    }

    const className = [
        'cs-sidebar-share-post mt-3',
        collapsed ? 'cs-sidebar-share-post--collapsed' : '',
    ].filter(Boolean).join(' ')

    return (
        <div className={className}>
            {collapsed ? (
                <Button
                    variant="rounded"
                    color="inverse"
                    icon={<IconPlus />}
                    onClick={handleClick}
                    tooltip={t('sidebar.sharePost')}
                    preventLoading
                />
            ) : (
                <Button
                    variant="rounded"
                    color="inverse"
                    fullWidth
                    startIcon={<IconPlus />}
                    onClick={handleClick}
                    preventLoading
                >
                    {t('sidebar.sharePost')}
                </Button>
            )}

            <PublishPostModal modalRef={modalRef} />
        </div>
    )
}
